module.exports = __webpack_public_path__ + "img/deluxeEdition.51105fd0.png";